import { render } from "./TranslationCreate.vue?vue&type=template&id=b341d052&ts=true"
import script from "./TranslationCreate.vue?vue&type=script&lang=ts"
export * from "./TranslationCreate.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__